import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import CloseIcon from '@/assets/svg/Cross';
import BookingWidget from './BookingWidget';

import { Container, CloseButton, Scroll } from './styles';

const BookingModal = ({ onClose }) => {
  const closeRef = useRef(null);

  useEffect(() => {
    const html = document.documentElement;
    const previousOverflow = html.style.overflow;
    const previouslyFocused = document.activeElement;

    html.style.overflow = 'hidden';
    closeRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      html.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
      if (previouslyFocused instanceof HTMLElement) previouslyFocused.focus();
    };
  }, [onClose]);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <Container role="dialog" aria-modal="true" aria-label="Termin buchen">
      <CloseButton ref={closeRef} type="button" onClick={onClose} aria-label="Schliessen">
        <CloseIcon />
      </CloseButton>
      <Scroll>
        <BookingWidget />
      </Scroll>
    </Container>,
    document.body
  );
};

BookingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default BookingModal;
